import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function TranscriptViewer({
  transcriptRaw,
  transcriptCleaned,
}) {
  const { t } = useLanguage();
  const [showOriginal, setShowOriginal] = useState(false);

  const raw = transcriptRaw?.trim() || '';
  const cleaned = transcriptCleaned?.trim() || '';
  const hasOriginal = Boolean(raw && cleaned && raw !== cleaned);

  if (!raw && !cleaned) return null;

  const displayText = showOriginal ? raw : cleaned || raw;

  return (
    <details className="rounded-xl border border-gray-200 bg-gray-50 p-3">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium text-gray-600 [&::-webkit-details-marker]:hidden">
        <span>{t('viewTranscript')}</span>
        {hasOriginal && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowOriginal((v) => !v);
            }}
            className="text-xs font-medium text-gray-400 hover:text-gray-600"
          >
            {showOriginal ? t('showCleaned') : t('showOriginal')}
          </button>
        )}
      </summary>

      <p
        dir={showOriginal ? 'auto' : 'ltr'}
        className="mt-2 text-sm leading-relaxed text-gray-700"
      >
        {displayText}
      </p>
    </details>
  );
}
